export default __webpack_public_path__ + "static/media/EM0999.34I-41696_-25027_0.ed1d7dc5.jpg";